import { getApiUrl } from "../utils/get-api-url";

const parser = new DOMParser();

export default (username, b64Val, programID, config) =>
  new Promise((resolve, reject) => {
    const apiUrl = getApiUrl("ixauthpxserver");
    const fullUrl = `${apiUrl}/users/${username}`;
    fetch(fullUrl, {
      method: "GET",
      headers: {
        Authorization: `Basic ${b64Val}`,
        "content-type": "text/xml"
      }
    })
      .then(response => response.text())
      .then(text => {
        // Build pxServer jQuery object
        const pxServerUser = parser.parseFromString(text, "text/xml");

        // role list from config, options will vary between SageSure, FNIC, etc
        const roleList = config.envConfig.ipcm.values.loginWhitelist || [
          "CRU_AGENT_NY_HO",
          "PX_MANAGER"
        ];
        const rolesNode = pxServerUser.querySelector("roles");
        const hasRole = roleList.some(role =>
          rolesNode.querySelector(`role[id="${role}"]`)
        );

        const rightsNode = pxServerUser.querySelector("rights");
        const hasRight = !!rightsNode.querySelector(
          `right[softwareapplication="agentportal"][organization="${programID}"][action="login"][access="grant"]`
        );

        // testing both in case there is an issue with the right being attached in the xml
        // or another role supporting login rights.  As long as one exists, we are good,
        // but if both are missing, the user does not have rights to login.
        if (hasRole || hasRight) {
          resolve(pxServerUser);
          return;
        }
        reject("Missing permissions.");
      })
      .catch(e => {
        console.error(e);
        reject("Missing permissions.");
      });
  });
